<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-no"><span class="cno">CONTENTS</span></h2>
<p class="toc"><a href="#/xhtml/chap01"><span class="tno">Chapter 1:</span> The Undercurrent</a></p>
<p class="toc"><a href="#/xhtml/chap02"><span class="tno">Chapter 2:</span> Sharing My Passion as a Fellow Pilgrim</a></p>
<p class="toc"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter 3:</span> Sailing the Couple’s Spiritual Catamaran on the Channels of Grace</span></p>
<p class="toc"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter 4:</span> Like a Catamaran at Sea</span></p>
<p class="toc"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter 5:</span> The Awe-Full Life – Worship</span></p>
<p class="toc"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter 6:</span> What’s God’s Will for Us? – Bible Reading</span></p>
<p class="toc"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter 7:</span> Learning to Listen – Prayer</span></p>
<p class="toc"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter 8:</span> Cooperating with God – Service</span></p>
<p class="toc"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter 9:</span> From a Taking to a Giving Life – Simplicity</span></p>
<p class="toc"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter 10:</span> Wowed by God! – Gratitude</span></p>
<p class="toc"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="tno">Chapter 11:</span> Overcoming Inertia</span></p>
<p class="toc"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="tno">Chapter 12:</span> Your Journey Together Awaits</span></p>
<p class="tocnt"><span href="#/xhtml/bm01" title="Link target outside of Sample">Resources: Want to Dive Deeper?</span></p>
<p class="tocn"><span href="#/xhtml/bm02" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?87a4dd38